import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { AppCommonModule } from './common/app.common/app.common.module';
import { GrameenphoneDocsComponent } from './pages/config/grameenphone-docs/grameenphone-docs.component';
import { DocumentationComponent } from './pages/config/banglalink/documentation/documentation.component';
import { RobiDocumentationComponent } from './pages/config/robi/robi-documentation/robi-documentation.component';
import { NgDocumentationComponent } from './pages/config/nagad/ng-documentation/ng-documentation.component';
import { ReportingModule } from './pages/reporting/reporting.module'; 
import { HasRolesDirective } from './_directives/has-roles.directive';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    GrameenphoneDocsComponent,
    DocumentationComponent,
    RobiDocumentationComponent,
    NgDocumentationComponent,
    HasRolesDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    AppCommonModule,
    ReactiveFormsModule,
    ReportingModule,
    NzDrawerModule
    
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
